import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rolesjobs',
    templateUrl: './rolesjobs.component.html',
    styleUrls: ['./rolesjobs.component.css']
})

export class RolesjobsComponent implements OnInit {

    constructor() {

    }

    ngOnInit() {

    }

}
